import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button,Select } from 'semantic-ui-react';
import  Notifications,{notify } from 'react-notify-toast';
import '../css/Login.css';
import { BaseURL } from '../../api/Service';
const APIURL = '/api/new/user/';
class Signup extends Component {
    constructor(props){
        super(props);
        this.state = {
            fname : "",
            mname : "",
            lname: "",
            type: "100",
            unique_no: "",
            gender: "",
            contact: "",
            email : "",
            roll_state: true,
            password:'',
            confirmpassword: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.addUserReq = this.addUserReq.bind(this);
    }
    addUserReq(val) {
        console.log(val);
        fetch(`${BaseURL}api/user/new`, {
            method: 'post',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(val)
        })
            .then(resp => {
                //console.log(resp)
                if (!resp.ok) {
                    if (resp.status >= 400 && resp.stats < 500) {
                        return resp.json().then(data => {
                            let err = { errorMessage: data.message };
                            notify.show(err.errorMessage, "warning", 2000);
                            throw err;
                        })
                    }
                    else {
                        let err = { errorMessage: "Please try again later" };
                        notify.show('Something went Wrong!!', "warning", 2000);
                        throw err;
                    }
                }
                return resp.json()
            })
            .then((m) => {
                notify.show(m.message, "info", 5000);
                //console.log(m);
                this.setState({
                    fname: "",
                    mname: "",
                    lname: "",
                    type: "100",
                    unique_no: "",
                    gender: "",
                    contact: "",
                    email: "",
                    password: '',
                    confirmpassword: '',
                    roll_state: true
                });
            });
    }
    handleSubmit(e) {
        e.preventDefault();
        notify.show('Form Submitted! Please Wait ....', "success", 2000);
        if(this.state.password !== '' && this.state.password === this.state.confirmpassword){
            const name = this.state.fname + ' ' + this.state.mname + ' ' + this.state.lname;
            const details = {
                name: name,
                gender: this.state.gender,
                contact: this.state.contact
            }
            const data = {
                "type": this.state.type,
                "unique_no": this.state.unique_no,
                "details": details,
                "email": this.state.email,
                "password": this.state.password
            }
            this.addUserReq(data);
        }else{
            notify.show('Passwords don\'t match ....Try again', "error", 2000);
        }
        
    }
    handleChange(e) {
        if(e.target.name === 'type'){
            let status = true;
            if(e.target.value === '100'){
                status = true;
            }else{
                status = false;
            }
            this.setState({
                roll_state: status
            })
        }
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    render() {
        return (
            
            <section className="container_create">
                <Notifications />
                <section className="card card_create">
                    <header className="card-content card-header_create">
                        <h2>Assam Engineering College<br/>Signup</h2>
                    </header>
                    <section className="card-content">
                       <Form
                        onSubmit={this.handleSubmit}
                        >
                           <Form.Group widths="equal">
                                <Form.Input fluid label='First name' 
                                    placeholder='First name' 
                                    name="fname" 
                                    onChange={this.handleChange} 
                                    value={this.state.fname} />
                                <Form.Input fluid label='Middle name' 
                                    placeholder='Middle name'
                                    name="mname"
                                    onChange={this.handleChange}
                                    value={this.state.mname} />
                                <Form.Input fluid label='Last name' 
                                    placeholder='Last name'
                                    name="lname"
                                    onChange={this.handleChange}
                                    value={this.state.lname} />
                           </Form.Group>


                            <Form.Group widths="equal">
                                <Form.Field label='Choose type' 
                                        control='select' 
                                        onChange={this.handleChange} 
                                        name="type"
                                        value={this.state.type}
                                        >
                                    <option value='100'>Student</option>
                                    <option value='200'>Employee</option>
                                </Form.Field>
                                {this.state.roll_state ? <Form.Input fluid label='Roll no' placeholder='Roll No' name="unique_no" onChange={this.handleChange} value={this.state.unique_no} /> : <Form.Input fluid label='Employee Id' placeholder='Employee Id' name="unique_no" onChange={this.handleChange} value={this.state.unique_no} /> }
                            </Form.Group>

                            <Form.Group widths="equal">
                                <Form.Field label='Gender' control='select'
                                    onChange={this.handleChange}
                                    name="gender"
                                    value={this.state.gender}>
                                    <option value='male'>Male</option>
                                    <option value='female'>Female</option>
                                    <option value='others'>Others</option>
                                </Form.Field>
                                <Form.Input fluid label='Contact No' 
                                    placeholder='Contact No' 
                                    name="contact"
                                    onChange={this.handleChange}
                                    value={this.state.contact}
                                    />
                            </Form.Group>
                           
                            
                           

                            <Form.Field>
                                <label>Email Id (must end with aec.ac.in e.g. someone@aec.ac.in)</label>
                                <input
                                    type="email"
                                    placeholder="Your email id"
                                    name="email"
                                    onChange={this.handleChange}
                                    value={this.state.email}
                                />
                            </Form.Field>

                            <Form.Group widths="equal">
                                <Form.Input fluid label='Password'
                                    type="password"
                                    placeholder='Password'
                                    name="password"
                                    onChange={this.handleChange}
                                    value={this.state.password} />
                                <Form.Input fluid label='Confirm Password'
                                    type="password"
                                    placeholder='Confirm Password'
                                    name="confirmpassword"
                                    onChange={this.handleChange}
                                    value={this.state.confirmpassword} />
                            </Form.Group>

                            <Button>Submit</Button>
                       </Form>
                    </section>
                </section>
                
            </section>
            
        );
    }
}
export default Signup;


// WEBPACK FOOTER //
// ./src/auth_components/js/Signup.js